const CREDENTIALS_KEY = 'gooval-open-api-credentials'
const LEGACY_CREDENTIALS_KEYS = [
  'gwofy-open-api-credentials',
  'gwofy-open-api-debug-config'
]

export function loadCredentials () {
  try {
    const raw = localStorage.getItem(CREDENTIALS_KEY)
    if (raw) {
      const p = JSON.parse(raw)
      return normalizeCredentials(p)
    }
  } catch (_) { /* ignore */ }

  for (const legacyKey of LEGACY_CREDENTIALS_KEYS) {
    try {
      const legacy = localStorage.getItem(legacyKey)
      if (legacy) {
        const p = JSON.parse(legacy)
        const normalized = normalizeCredentials({
          storeNumber: p.storeNumber,
          apiKeyId: p.apiKeyId,
          apiSecret: p.apiSecret
        })
        saveCredentials(normalized)
        return normalized
      }
    } catch (_) { /* ignore */ }
  }

  return emptyCredentials()
}

export function saveCredentials (credentials) {
  const normalized = normalizeCredentials(credentials)
  localStorage.setItem(CREDENTIALS_KEY, JSON.stringify(normalized))
  return normalized
}

export function emptyCredentials () {
  return { storeNumber: '', apiKeyId: '', apiSecret: '' }
}

function normalizeCredentials (raw) {
  return {
    storeNumber: String(raw?.storeNumber ?? '').trim(),
    apiKeyId: String(raw?.apiKeyId ?? '').trim(),
    apiSecret: String(raw?.apiSecret ?? '').trim()
  }
}

/** 弹窗必填：API Key ID + Secret；发请求还需 Store Number */
export function needsCredentialDialog (credentials) {
  const c = normalizeCredentials(credentials)
  return !c.apiKeyId || !c.apiSecret
}

export function credentialsReadyForRequest (credentials) {
  const c = normalizeCredentials(credentials)
  return !!(c.storeNumber && c.apiKeyId && c.apiSecret)
}
